import { LooksTwo } from "@mui/icons-material";
import { CustomAutocomplete } from "../../../../components/custom/CustomAutocomplete";
import { useGlobalMarketSpreadPriceContext } from "../../../../context/global-market/GlobalMarketSpreadPriceContext";
import { Box, Typography } from "@mui/material";
import { COLORS } from "../../../../ui/Theme";
import Grid2 from "@mui/material/Unstable_Grid2";

const SpreadPriceForm2 = () => {
  const {
    industries2,
    commodityTypes2,
    commodities2,
    transitTypes2,
    inputValues2,
    setInputValues2,
  } = useGlobalMarketSpreadPriceContext();

  const { industry, commodityType, commodity, transitType } = inputValues2;

  const clearForm = (field) => {
    switch (field) {
      case "industry":
        setInputValues2((prev) => ({
          ...prev,
          commodityType: null,
          commodity: null,
          transitType: null,
        }));
        break;
      case "commodityType":
        setInputValues2((prev) => ({
          ...prev,
          commodity: null,
          transitType: null,
        }));
        break;
      case "commodity":
        setInputValues2((prev) => ({
          ...prev,
          transitType: null,
        }));
        break;

      default:
        break;
    }
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: "10px",
      }}
    >
      <Typography
        sx={{
          fontSize: "16px",
          fontWeight: 900,
          display: "flex",
          alignItems: "center",
          justifyContent: { xs: "center", md: "flex-start" },

          gap: 0.5,
        }}
      >
        کالا
        <LooksTwo sx={{ color: COLORS.BLUE }} />
      </Typography>

      <Grid2 container spacing={"10px"}>
        <Grid2 xs={12} md={3}>
          <CustomAutocomplete
            options={industries2.data}
            value={industry}
            onChange={(e, newValue) => {
              setInputValues2((prev) => ({ ...prev, industry: newValue }));
              clearForm("industry", newValue);
            }}
            isLoading={industries2.isLoading}
            placeholder="صنعت"
          />
        </Grid2>
        <Grid2 xs={12} md={3}>
          <CustomAutocomplete
            options={commodityTypes2.data}
            value={commodityType}
            onChange={(e, newValue) => {
              setInputValues2((prev) => ({ ...prev, commodityType: newValue }));
              clearForm("commodityType", newValue);
            }}
            isLoading={commodityTypes2.isLoading}
            placeholder="نوع کالا"
          />
        </Grid2>
        <Grid2 xs={12} md={3}>
          <CustomAutocomplete
            options={commodities2.data}
            value={commodity}
            onChange={(e, newValue) => {
              setInputValues2((prev) => ({
                ...prev,
                commodity: newValue,
              }));
              clearForm("commodity", newValue);
            }}
            isLoading={commodities2.isLoading}
            placeholder="کالا (اختیاری)"
          />
        </Grid2>
        <Grid2 xs={12} md={3}>
          <CustomAutocomplete
            options={transitTypes2.data}
            value={transitType}
            onChange={(e, newValue) => {
              setInputValues2((prev) => ({
                ...prev,
                transitType: newValue,
              }));
              clearForm("transitType", newValue);
            }}
            isLoading={transitTypes2.isLoading}
            placeholder="نوع حمل و نقل (اختیاری)"
          />
        </Grid2>
      </Grid2>
    </Box>
  );
};

export default SpreadPriceForm2;
